<!-- eslint-disable vuejs-accessibility/heading-has-content -->

<div class="SchoolpageZittenblijven_container_1yLcC"><div><div class="mb-4 ZittenblijversTile_root_1pDtu"><div class="ZittenblijversTile_header_38GNC"><h5 class="ZittenblijversTile_jaar_n0rLh my-0"> 2021-22
	naar 2022-23 </h5><div><span class="ZittenblijversTile_label_7hsFk">aantal leerlingen: </span><span class="ZittenblijversTile_value_3P_hl">1074</span></div></div><div class="ZittenblijversTile_subjectContainer_2Cj8A"><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">zittenblijvers</span><span class="ZittenblijversTile_value_3P_hl">77</span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">pct.</span><span class="ZittenblijversTile_value_3P_hl">7.2% </span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">gem. Amsterdam</span><span class="ZittenblijversTile_value_3P_hl"> 7.0% </span></div></div><div class="ZittenblijversTile_subjectContainer_2Cj8A"><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">afstromers</span><span class="ZittenblijversTile_value_3P_hl">23</span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">pct.</span><span class="ZittenblijversTile_value_3P_hl">2.1% </span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">gem. Amsterdam</span><span class="ZittenblijversTile_value_3P_hl"> 2.5% </span></div></div><div class="ZittenblijversTile_subjectContainer_2Cj8A"><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">opstromers</span><span class="ZittenblijversTile_value_3P_hl">11</span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">pct.</span><span class="ZittenblijversTile_value_3P_hl"> 1.0% </span></div><div class="ZittenblijversTile_valueContainer_EHVeK"><span class="ZittenblijversTile_label_7hsFk">gem. Amsterdam</span><span class="ZittenblijversTile_value_3P_hl"> 6.2% </span></div></div></div></div><button class="btn btn--black w-100"> Toon meer schooljaren </button><!----></div>
<template>
  <main>
    <h2 v-if="loadingSchool">
      <div>Loading school</div>
      <h2 class="spin-loader" />
    </h2>
    <h3 v-if="!loadingSchool && !school">
      No school found
    </h3>

    <div
      v-if="school"
      id="school"
      class="row"
    >
<div class="col-md-8">
	<h2>{{ school.lange_naam || school.naam }}</h2>

        <p class="lead">
          {{ school.denominatie }} | {{ school.onderwijsconcept }}  <br>
		  <span v-if="school.cluster">  cluster {{ school.cluster }} | {{ school.specificatie }}<br></span>
          {{ school.soort_onderwijs }} |  <br>
          {{ school.soort_onderwijs_extra }}
	</p>

        <skeleton-loader
          v-if="loadingLeerlingaantallen"
          :types="['h1', 'input']"
        />
        <schoolpage-leerlingaantallen-grafiek
          v-if="leerlingaantallen"
          :school="school"
          :leerlingaantallen="leerlingaantallen"
        />

        <schoolpage-contact :school="school" />

        <!-- VO Exclusive -->
        <skeleton-loader
          v-if="loadingOpendagen"
          :types="['loader', 'h1', 'input', 'input']"
        />

        <!-- Hide the aanmeldingen for now -->
        <schoolpage-aanmelding
          v-if="false && opendagen"
          v-show="!['po', 'sbo'].includes(school.type)"
          :school="school"
          :opendagen="opendagen"
        />

        <schoolpage-onderwijs :school="school" />

        <skeleton-loader
          v-if="loadingJaren"
          :types="['loader', 'h1', 'input']"
        />
        <schoolpage-leerlingen
          v-if="leerlingaantallen"
          v-show="!['po', 'sbo'].includes(school.type)"
          :school="school"
          :leerlingaantallen="leerlingaantallen"
        />
        <schoolpage-brugperiode :school="school" />
        <schoolpage-zorg
          v-if="false"
          :school="school"
        />

        <schoolpage-voorzieningen :school="school" />
        <schoolpage-extra
          v-if="jaren"
          :school="school"
          :jaren="jaren"
        />
        <schoolpage-kwaliteit
          v-if="jaren"
          :school="school"
          :jaren="jaren"
        />

        <schoolpage-eindexamen :school="school" />

        <schoolpage-zittenblijven
          v-if="school.type === 'vo'"
          :school="school"
        />

        <p v-if="school.updated_at">
          <span class="small">
            laatst aangepast op
            {{ new Date(school.updated_at).toLocaleDateString() }}
          </span>
        </p>
      </div>

      <div
        id="sidebar"
        class="col-md-4 content-block-sidebar"
      >
        <schoolpage-map
          v-if="school"
          :school="school"
        />
        <schoolpage-video :school="school" />

        <schoolpage-artikelen :school="school" />
        <schoolpage-schoolgidsen :school="school" />

        <schoolpage-links-external :school="school" />
        <schoolpage-inspectie-rapporten :school="school" />
      </div>
    </div>
  </main>
</php>
</template>
<script>
import { setPageTitle, setMetaDescription } from '@/library/seo-helper';
import SchoolpageContact from './SchoolpageContact.vue';
import SchoolpageLeerlingaantallenGrafiek from './SchoolpageLeerlingaantallenGrafiek.vue';

import SchoolpageAanmelding from './SchoolpageAanmelding.vue';
import SchoolpageOnderwijs from './SchoolpageOnderwijs.vue';

import SchoolpageLeerlingen from './SchoolpageLeerlingen.vue';
import SchoolpageBrugperiode from './SchoolpageBrugperiode.vue';
import SchoolpageZorg from './SchoolpageZorg.vue';
import SchoolpageVoorzieningen from './SchoolpageVoorzieningen.vue';

import SchoolpageExtra from './SchoolpageExtra.vue';
import SchoolpageKwaliteit from './SchoolpageKwaliteit.vue';

import SchoolpageMap from './SchoolpageMap.vue';
import SchoolpageVideo from './SchoolpageVideo.vue';
import SchoolpageArtikelen from './SchoolpageArtikelen.vue';
import SchoolpageSchoolgidsen from './SchoolpageSchoolgidsen.vue';
import SchoolpageLinksExternal from './SchoolpageLinksExternal.vue';
import SchoolpageInspectieRapporten from './SchoolpageInspectieRapporten.vue';
import SchoolpageZittenblijven from './SchoolpageZittenblijven.vue';

import SchoolpageEindexamen from './SchoolpageEindexamen.vue';

import scholenRepository from '../../repositories/scholenRepository';

import SkeletonLoader from '../../components/SkeletonLoader.vue';
import schoolService from '../../services/schoolService';

export default {
  components: {
    SchoolpageContact,
    SchoolpageLeerlingaantallenGrafiek,

    SchoolpageAanmelding,
    SchoolpageOnderwijs,
    SchoolpageLeerlingen,
    SchoolpageBrugperiode,
    SchoolpageZorg,
    SchoolpageVoorzieningen,

    SchoolpageExtra,
    SchoolpageKwaliteit,

    SchoolpageMap,
    SchoolpageVideo,
    SchoolpageArtikelen,
    SchoolpageSchoolgidsen,
    SchoolpageLinksExternal,
    SchoolpageInspectieRapporten,
    SchoolpageZittenblijven,

    SchoolpageEindexamen,

    SkeletonLoader,
  },
  props: {
    brin: {
      required: false,
      default: null,
      type: String,
    },
    naam: {
      required: false,
      default: null,
      type: String,
    },
  },
  data() {
    return {
      loadingSchool: false,
      loadingOpendagen: false,
      loadingJaren: false,
      loadingLeerlingaantallen: false,

      school: null,
      opendagen: null,
      jaren: null,

      leerlingaantallen: null,
    };
  },
  created() {
    try {
      ga('set', 'page', `/scholenoverzicht${this.$route.path}`); // should include the whole path
      ga('send', 'pageview');
    } catch (e) {
      console.log('Analytics error');
    }
    this.loadingSchool = true;
    this.loadingOpendagen = true;
    this.loadingJaren = true;
    this.loadingLeerlingaantallen = true;

    this.loadSchool().then(() => {
      this.loadingSchool = false;

      this.loadOpendagen().then(() => {
        this.loadingOpendagen = false;
      });

      this.loadJaren().then(() => {
        this.loadingJaren = false;
      });

      this.loadLeerlingaantallen().then(() => {
        this.loadingLeerlingaantallen = false;
      });
    });
  },
  methods: {
    async loadSchool() {
      return scholenRepository.get(this.$route.params.brin).then(({ data }) => {
        this.school = data;

        setPageTitle(`${this.school.lange_naam} | OCO scholenoverzicht`);
        setMetaDescription(
          `Onafhankelijke informatie van OCO over ${this.school.lange_naam} voor een bewuste en verantwoorde schoolkeuze.`,
        );
      });
    },
    async loadOpendagen() {
      if (!this.school) {
        return;
      }
      scholenRepository
        .listSchoolOpendagen({ 'where[school_id]': this.school.id })
        .then(({ data }) => {
          this.opendagen = data;
        });
    },
    async loadJaren() {
      if (!this.school) {
        return;
      }
      scholenRepository
        .listSchoolJaren({ 'where[school_id]': this.school.id }, this.school.type)
        .then(({ data }) => {
          this.jaren = data;
        });
    },
    async loadLeerlingaantallen() {
      if (!this.school) {
        return;
      }
      schoolService.getLeerlingAantallen(this.school).then((data) => {
        this.leerlingaantallen = data;
      });
    },
  },
};
</script>
<style scoped>
  .cluster-box {
    background-color: #000; /* Zwart achtergrondkleur */
    color: #fff; /* Witte tekstkleur */
    padding: 10px;
    border-radius: 5px;
    width: 100px;
    height: 100px;
    float: right;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .cluster-label {
	font-family: futura-pt;
    font-weight: bold;
    margin-bottom: 5px;
	text-transform: uppercase;
	font-size: 20px;

  }
  .cluster-number{
	font-family: futura-pt;
	font-size: 40px;
  }
</style>
